import React, {useEffect, useState} from 'react';

import {makeStyles} from 'tss-react/mui';
import {useTranslation} from 'react-i18next';
import {Checkbox, Chip, CustomAutocomplete} from 'web-library';
import {MedicalCondition} from '../../../../api/candidate/access-arrangement/model';
import {
  ErrorObject,
  FormIds,
} from '../../../../modules/accessArrangment/components/candidate/SelectCondition/components/SelectConditionContent';
import {MenuItem} from "../../../../api";

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export const useStyles = makeStyles<{ selectedMedicalCondition: MenuItem[], showError: boolean }>()((theme, {
  selectedMedicalCondition,
  showError
}) =>
    ({
      chipsContainer: {
        overflowX: 'hidden',
        width: '100%',
      },
      iconButton: {
        position: 'absolute',
        right: '45px',
        top: 'calc(50% - 12px)',
        padding: 0,
      },
      chipLabel: {
        padding: 0,
      },
      rootContainer: {
        display: 'flex',
        alignItems: 'center',
        minHeight: theme.spacing(6),
        padding: '0 25px 0 16px !important',
        backgroundColor: selectedMedicalCondition.length === 0 && showError ? theme.color.state.stateErrorLight : '',
        borderColor: selectedMedicalCondition.length === 0 && showError ? theme.color.state.stateError : '',
      },
      arrowIconContainer: {
        right: '-10px',
      },
      errString: {
        marginTop: theme.spacing(1),
        color: theme.color.state.stateError,
      },
    }));

interface SelectMenuProps {
  medicalConditions: MedicalCondition[];
  setIsOthersSelected: (isOthers: boolean) => void;
  setShowUploadDocuments: (showUploadDocuments: boolean) => void;
  selectedMedicalCondition: MenuItem[];
  onSelectMedicalCondition: (newSelectedArray: MenuItem[]) => void;
  error?: ErrorObject;
  showError: boolean;
  amendment: boolean;
}

const SelectMenu = ({
                      medicalConditions,
                      setIsOthersSelected,
                      setShowUploadDocuments,
                      selectedMedicalCondition,
                      onSelectMedicalCondition,
                      error,
                      showError,
                      amendment,
                    }: SelectMenuProps) => {
  const {t} = useTranslation();
  const [menuItems, setMenuItems] = useState<MenuItem[]>([]);
  const {classes} = useStyles({selectedMedicalCondition, showError});

  useEffect(() => {
    const isOthersSelected = selectedMedicalCondition.some(
      (conditionIndex) =>
        medicalConditions
          .find((condition) => condition.uuid === conditionIndex.key)
          ?.name.toLowerCase() === 'others'
    );
    setIsOthersSelected(isOthersSelected);
  }, [medicalConditions, setIsOthersSelected, selectedMedicalCondition]);

  useEffect(() => {
    if (!amendment) {
      setShowUploadDocuments(selectedMedicalCondition.length > 0);
    }

    setMenuItems(
        medicalConditions
        .filter((medicalCondition) => {
          if (medicalCondition.invalid) {
            return selectedMedicalCondition.some(
                (selectedCondition) => selectedCondition.value === medicalCondition.uuid
            );
          }
          return true;
        })
        .map((condition, index) => ({
          children: condition.name,
          key: `k-${condition.uuid}`,
          value: condition.uuid,
        }))
    );
  }, [amendment, setShowUploadDocuments, selectedMedicalCondition, medicalConditions]);


  return (
      <>
        <CustomAutocomplete<MenuItem, true, false, undefined>
            className={`${error && showError ? classes.errString : ''}`}

            id={FormIds.MEDICAL_CONDITION_SELECT_MENU}
            label={amendment
                ? t('accessArrangement->>SelectCondition.AdditionalMedicalConditions')
                : t('accessArrangement->>SelectCondition.MedicalConditions')}
            multiple
            placeholder={t('accessArrangement->>SelectCondition.SelectMedicalConditions')}
            options={menuItems}
            disableCloseOnSelect
            renderOption={(_, option, {selected}, __) => <>
              <Checkbox
                  style={{padding: '9px'}} checked={selected}
              />
              {option.children}
            </>}
            value={selectedMedicalCondition}
            onChange={(_e, value) => onSelectMedicalCondition(value)}
            getOptionLabel={(option) => option.children}
            isOptionEqualToValue={(option, value) => option.key === value.key}
            error={showError && !!error?.text}
            helperText={showError ? error?.text : ''}
            renderTags={(tagValue, getTagProps) =>
                tagValue.map((option, tagIndex) => (
                    <Chip
                        {...getTagProps({index: tagIndex})}
                        key={`chip-${option.key}`}
                        id={`chip-medical-condition-${option.key}`}
                        label={option.children}
                    />
                ))
            }
        />
      </>
  );
};

export default SelectMenu;
